import { render, staticRenderFns } from "./communityJoin.vue?vue&type=template&id=80c3ebb2&scoped=true&"
import script from "./communityJoin.vue?vue&type=script&lang=js&"
export * from "./communityJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c3ebb2",
  null
  
)

export default component.exports